"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPreferencesSchema = void 0;
const zod_1 = require("zod");
exports.UserPreferencesSchema = zod_1.z.object({
    // Whether the bar is open or not, defaults to true
    barOpen: zod_1.z.boolean().optional().default(true),
    // Controls the light or dark mode of the bar
    theme: zod_1.z.union([zod_1.z.literal("light"), zod_1.z.literal("dark"), zod_1.z.literal("system")]),
    // The key bindng to show or hide the bar
    showHotKey: zod_1.z.string().optional().default("`"),
});
